import script from "./ReservationSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationSuccess.vue?vue&type=style&index=0&id=584b023e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584b023e"]])

export default __exports__